<template>
  <div>
    <div class="vb_list">
      <swiper class="boutique_swiper" :options="swiperOptionsVideoBtq">
        <swiper-slide v-for="(item, index) in videoList" :key="index">
          <div class="vb_item">
            <div class="vb_img">
              <a :href="'/old-album?id=' + item.id" target="_blank"
                ><img :src="item.src" alt=""
              /></a>
            </div>
            <div class="cvl_title">{{ item.title }}</div>
          </div>
        </swiper-slide>
      </swiper>
      <div
        class="swiper-button-next boutique-button-next el-icon-arrow-right"
        slot="pagination"
      ></div>
      <div
        class="swiper-button-prev boutique-button-prev el-icon-arrow-left"
        slot="pagination"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swiperOptionsVideoBtq: {
        navigation: {
          nextEl: ".boutique-button-next",
          prevEl: ".boutique-button-prev",
        },
        slidesPerView: 7,
      },
      videoList: [
        {
          id: 1,
          title: "蓝迪安全教育",
          src: "http://vphoto.kepuchina.cn/images/2017821501654836625_39.jpg",
        },
        {
          id: 2,
          title: "鹿精灵",
          src: "http://vphoto.kepuchina.cn/images/2017/12/22/201712221513905424827_39.png",
        },
        {
          id: 3,
          title: "科普中国之酷杰的科学之旅",
          src: "http://vphoto.kepuchina.cn/images/2017/11/23/201711231511401202625_39.png",
        },
        {
          id: 4,
          title: "科普中国之阿U学科学",
          src: "http://vphoto.kepuchina.cn/images/2017/11/23/201711231511416886215_39.jpg",
        },
        {
          id: 5,
          title: "科普中国之小樱桃读科学",
          src: "http://vphoto.kepuchina.cn/images/2017/11/23/201711231511417001721_39.jpg",
        },
        {
          id: 6,
          title: "科普中国之可可小爱",
          src: "http://vphoto.kepuchina.cn/images/2017/8/21/20178211503302661651_39.jpg",
        },
        {
          id: 7,
          title: "小破孩儿禁毒系列",
          src: "http://vphoto.kepuchina.cn/images/2017/7/17/20177171500275873891_39.jpg",
        },
        {
          id: 8,
          title: "《聪明的顺溜》第一季",
          src: "http://vphoto.kepuchina.cn/images/2017/7/17/20177171500275938592_39.jpg",
        },
        {
          id: 9,
          title: "BABY驾到",
          src: "http://vphoto.kepuchina.cn/images/2017/7/17/20177171500275963142_39.jpg",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.vb_list {
  position: relative;

  .vb_item {
    width: 110px;

    .vb_img {
      position: relative;
      width: 100%;
      height: 110px;
      overflow: hidden;
      border-radius: 50%;

      img {
        width: 100%;
        height: auto;
      }
    }
    .cvl_title {
      height: 40px;
      margin-top: 10px;
      line-height: 18px;
      text-align: center;
      @include fontSize(18px, 400, #353535, 20px);
    }
  }

  .swiper-slide {
    margin-right: 10px;
  }

  .swiper-slide:nth-child(7) {
    margin: 0;
  }

  .swiper-container {
    position: relative;
    height: 100%;
  }

  .swiper-button-prev {
    top: 36px !important;
    left: 0 !important;
    width: 28px;
    height: 37px;
    margin-top: 0;
    background: #f4f4f4;
    border-radius: 0 100px 100px 0;
  }

  .swiper-button-next {
    top: 36px !important;
    right: 0 !important;
    width: 28px;
    height: 37px;
    margin-top: 0;
    background: #f4f4f4;
    border-radius: 100px 0 0 100px;
  }

  .swiper-button-prev::after {
    content: " ";
    //margin-left: -6px;
    //font-size: 18px;
    //font-weight: 600;
    //color: #979797;
  }

  .el-icon-arrow-left::before {
    margin-left: -6px;
    font-size: 24px;
    font-weight: 600;
    color: #979797;
  }

  .swiper-button-next::after {
    content: " ";
    //margin-left: 6px;
    //font-size: 18px;
    //font-weight: 600;
    //color: #979797;
  }
  .el-icon-arrow-right::before {
    margin-left: 6px;
    font-size: 24px;
    font-weight: 600;
    color: #979797;
  }
}
</style>
